module.exports = __webpack_public_path__ + "img/logo03.752c9bb3.jpg";